"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pouchdb = require("pouchdb");

var _pouchdb2 = _interopRequireDefault(_pouchdb);

var _format = require("ol/format");

var _source = require("ol/source");

var _loadingstrategy = require("ol/loadingstrategy");

var olLoadingstrategy = _interopRequireWildcard(_loadingstrategy);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VectorSource = function VectorSource(databaseUrl, opt) {
  var sourceOptions = Object.assign({
    fetch: undefined,
    replication: undefined
  }, opt, {
    featureProjection: undefined
  });

  var state = {
    featureProjection: null,
    changes: null,
    updateSeq: "now",
    source: null
  };

  var db = new _pouchdb2.default(databaseUrl, {
    fetch: function fetch(url, dbOptions) {
      var fetchOptions = opt ? opt.fetch : undefined;
      return _pouchdb2.default.fetch(url, Object.assign({}, dbOptions, fetchOptions));
    }
  });

  var geoJSONFormat = new _format.GeoJSON();

  var isString = function isString(str) {
    return typeof str === "string" || str instanceof String;
  };

  var removeDesignDocs = function removeDesignDocs(result) {
    return Object.assign({}, result, {
      rows: result.rows.filter(function (row) {
        return row.id.indexOf("_design") < 0;
      })
    });
  };

  var getAllDocs = function getAllDocs() {
    return db.allDocs({ include_docs: true, update_seq: true }).then(removeDesignDocs);
  };

  var appendUrlToAttachments = function appendUrlToAttachments(dbUrl) {
    return function (doc) {
      return Object.keys(doc._attachments || {}).map(function (key) {
        return _defineProperty({}, key, dbUrl + "/" + doc._id + "/" + key);
      });
    };
  };

  var parseAttachments = appendUrlToAttachments(databaseUrl);

  var rowToGeoJSON = function rowToGeoJSON(row) {
    return {
      type: "Feature",
      id: row.doc._id,
      properties: Object.assign.apply(Object, [{}].concat(_toConsumableArray(parseAttachments(row.doc)), [row.doc.properties, {
        _id: row.doc._id,
        _rev: row.doc._rev
      }])),
      geometry: row.doc.geometry
    };
  };

  var resultToGeoJSON = function resultToGeoJSON(result) {
    return {
      type: "FeatureCollection",
      features: result.rows.map(rowToGeoJSON)
    };
  };

  var geoJSONToFeatures = function geoJSONToFeatures(featureProjection) {
    return function (geoJSON) {
      return geoJSONFormat.readFeatures(geoJSON, {
        featureProjection: featureProjection,
        dataProjection: sourceOptions.dataProjection
      });
    };
  };

  var addFeatures = function addFeatures(features) {
    state.source.addFeatures(features);
  };

  var setDbUpdateSeq = function setDbUpdateSeq(updateSeq) {
    state.updateSeq = updateSeq;
  };

  var setDbUpdateSeqFromResult = function setDbUpdateSeqFromResult(result) {
    setDbUpdateSeq(result.update_seq);
    return result;
  };

  var sourceLoader = function sourceLoader(extent, resolution, featureProjection) {
    state.featureProjection = featureProjection;
    return getAllDocs().then(setDbUpdateSeqFromResult).then(function (result) {
      if (sourceOptions.replication) {
        startReplication();
      }
      return result;
    }).then(resultToGeoJSON).then(geoJSONToFeatures(featureProjection)).then(addFeatures);
  };

  var deleteFeature = function deleteFeature(id) {
    var feature = state.source.getFeatureById(id);
    if (feature) {
      state.source.removeFeature(feature);
    }
  };

  var handleDbChange = function handleDbChange(source) {
    return function (row) {
      var doc = row.doc;
      deleteFeature(doc._id);
      if (!doc._deleted) {
        source.addFeature(geoJSONFormat.readFeature(rowToGeoJSON(row), {
          featureProjection: state.featureProjection,
          dataProjection: sourceOptions.dataProjection
        }));
      }
    };
  };

  var startReplication = function startReplication(since) {
    if (since) {
      setDbUpdateSeq(since);
    }
    stopReplication();

    state.changes = db.changes({
      since: state.updateSeq,
      retry: true,
      live: true,
      include_docs: true
    }).on("change", handleDbChange(state.source)).on("error", console.error);
  };

  var stopReplication = function stopReplication() {
    if (state.changes) {
      state.changes.cancel();
      state.changes = null;
    }
  };

  var createSource = function createSource() {
    var source = new _source.Vector(Object.assign({}, sourceOptions, {
      strategy: olLoadingstrategy.all,
      loader: sourceLoader
    }));

    source.update = function () {
      source.clear(); // Will trigger a new call to souceLoader by OpenLayers
    };

    source.replication = {
      start: startReplication,
      stop: stopReplication
    };

    return source;
  };

  state.source = createSource();

  return state.source;
};

exports.default = VectorSource;
module.exports = exports["default"];